const e = {
  add: "Legg til",
  cancel: "Kanseller",
  clear: "Fjern",
  confirm: "Bekreft",
  delete: "Slett",
  redo: "Gjenta",
  save: "Lagre",
  saveAs: "Lagre som",
  undo: "Angre"
}, t = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, a = {
  cancel: "Kanseller",
  confirm: "Bekreft",
  datePlaceholder: "Velg dato",
  datetimePlaceholder: "Velg dato og tid",
  endDatePlaceholder: "Sluttdato",
  endDatetimePlaceholder: "Sluttdato og klokkeslett",
  endMonthPlaceholder: "Sluttmåned",
  monthPlaceholder: "Velg måned",
  now: "Nå",
  quarterPlaceholder: "Velg kvartal",
  selectDate: "Velg dato",
  selectTime: "Velg tid",
  startDatePlaceholder: "Startdato",
  startDatetimePlaceholder: "Startdato og klokkeslett",
  startMonthPlaceholder: "Startmåned",
  today: "I dag",
  weekPlaceholder: "Velg uke",
  yearPlaceholder: "Velg år",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, l = {
  placeholder: "Velg"
}, r = {
  clear: "Fjern",
  negativeText: "Kanseller",
  now: "Nå",
  placeholder: "Velg tid",
  positiveText: "OK"
}, o = {
  placeholder: "Skriv inn"
}, n = {
  placeholder: "Skriv inn"
}, s = {
  placeholder: "Begynn å skrive ..."
}, d = {
  allRows: "Alle rader",
  default: "Standard",
  deleteLayoutDescription: "Er du sikker på at du vil slette dette oppsettet?",
  discardChanges: "Forkast endringer",
  discardLayoutChanges: "Forkast endringer i oppsettet",
  enterLayoutName: "Skriv inn navn på oppsett",
  enterRowNumber: "Angi antall rader",
  fieldsSelected: "Valgte felter",
  freezeColumnDescription: "Frys kolonnen til venstre",
  freezeUptoColumn: "Frys opptil kolonne",
  frozen: "Frosset",
  layoutName: "Navn på oppsett",
  manageColumns: "Administrer kolonner",
  none: "Ingen",
  reorderRows: "Endre rekkefølgen på radene",
  rowsSelected: "rader er valgt",
  saveLayoutAs: "Lagre oppsett som",
  saveLayoutNew: "Lagre nytt oppsett",
  search: "Søke",
  searchColumnsPlaceholder: "Søke i kolonner",
  searchFieldsPlaceholder: "Søkefelt",
  selectAll: "Velg alle",
  setTableHeight: "Angi tabellhøyde",
  unfreeze: "Opphev frysing",
  unsavedChanges: "Du har endringer som ikke er lagret",
  unsavedChangesDescription: "Det kan være én eller flere endringer som ikke er lagret. Ønsker du å lagre dem?"
}, i = {
  at: "ved",
  colorAlreadyUsed: "Velge en annen farge eller bruk nåværende",
  colorNamePlaceholder: "Skriv inn navn",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Velg et annet fargenavn",
  noColorsAdded: "Du har ingen farger i denne seksjonen."
}, c = {
  searchPlaceholder: "Søke"
}, p = {
  invalidPastedData: "Ugyldig innlimt data."
}, g = {
  of: "av",
  page: "Side",
  rowsPerPage: "Rader per side"
}, k = {
  failedToUpload: "Kunne ikke laste opp.",
  retry: "Prøv på nytt",
  clickToUpload: "klikk for å siste opp",
  orDragAndDrop: "Eller Dra og slipp",
  supportedFileTypes: "Støttede filtyper:"
}, u = {
  global: e,
  Progress: t,
  DatePicker: a,
  Select: l,
  TimePicker: r,
  Input: o,
  InputNumber: n,
  InputTag: s,
  HLDataTable: d,
  ColorPicker: i,
  InputPhone: c,
  InputOtp: p,
  Pagination: g,
  Upload: k
};
export {
  i as ColorPicker,
  a as DatePicker,
  d as HLDataTable,
  o as Input,
  n as InputNumber,
  p as InputOtp,
  c as InputPhone,
  s as InputTag,
  g as Pagination,
  t as Progress,
  l as Select,
  r as TimePicker,
  k as Upload,
  u as default,
  e as global
};
